var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 93,
    viewBox: "0 0 77 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.73562 83.7023L0.859375 0H76.4124L69.5308 83.6907L38.5877 92.9964L7.73562 83.7023Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6007 17.1091H14.9141L17.4659 48.1535H38.6328V37.8887H26.1174L25.2525 27.3768H38.6328V17.1091H38.6007ZM38.6328 64.5155L38.5927 64.5272L28.0587 61.4408L27.3893 53.2539H17.889L19.2144 69.3719L38.59 75.1843L38.6328 75.1698V64.5155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6069 48.1535H50.2548L49.1837 61.464L38.6337 64.5533V75.2337L58.0254 69.4009L60.6227 37.8829H38.639L38.6069 48.1535ZM62.074 19.8642L62.2989 17.1091H38.6016V27.3739H61.4474L61.6348 25.0664L62.074 19.8642Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.3af2dc0455feaefd82a46ea2ef4fff29.svg";
export { ForwardRef as ReactComponent };